import React, { useState } from "react";
import { useNavigate,Link } from "react-router-dom"; // Import for routing
import { FaPhoneAlt, FaSearch, FaCheck, FaArrowRight } from "react-icons/fa";
import "../Css/HomeCleaningService.css";
import HomeCleaningImage from "../assets/service-6.jpg";




const HomeCleaningService = () => {

    const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");

  // List of your services
  const services = [
  { name: "Patient Care", path: "/services/patient-care-service-in-mumbai" },
  { name: "Baby Care", path: "/services/baby-care-service-in-mumbai" },
  { name: "House Maid", path: "/services/house-maid-service-in-mumbai" },
  { name: "Cooking", path: "/services/cooking-service-in-mumbai" },
  { name: "Driver", path: "/services/driver-service-in-mumbai" },
  { name: "Home Cleaning", path: "/services/home-cleaning-service-in-mumbai" },
  { name: "Japa Maid", path: "/services/japa-maid-service-in-mumbai" },
];

  // Filter logic
  const filteredServices = services.filter((item) =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  
  return (
    <div className="HomeCleaningService-page">
      {/* HERO SECTION - RETAINED AS REQUESTED */}
      <section className="HomeCleaningService-hero">
        <div className="HomeCleaningService-overlay">
          <div className="HomeCleaningService-hero-content">
            <h1>Home Cleaning Services</h1>
            <p>
              <span><a href="/">Home</a></span> / <span className="active">Home Cleaning Services</span>
            </p>
          </div>
        </div>
      </section>

      {/* SQUARE PREMIUM CONTENT */}
      <section className="main-section">
        <div className="container-square">
          <div className="content-layout">
            
            {/* Main Content Area */}
            <div className="article-box">
              <div className="square-img-holder">
                <img src={HomeCleaningImage} alt="Home Cleaning Service Services" />
                <div className="img-overlay-label">PREMIUM SERVICE</div>
              </div>

              <div className="text-header">
                <h2 className="title-bold">Hire Professional Cleaning Maid Service in Mumbai</h2>
                <h4 className="subtitle-line">Full-Service Cleaning Maid Mumbai</h4>
              </div>

              <div className="body-description">
                <p>Tanya Maid Service is your reliable partner for maintaining a spotless and sparkling home with our Home Cleaning Maid Service Mumbai. We specialize in providing well-trained, efficient, and background-verified maids who take care of every cleaning need—from daily dusting to deep home maintenance. Our goal is to make your living space clean, comfortable, and stress-free, giving you more time to focus on what truly matters.</p>
                <p>At Tanya Maid Service, we understand that every home is unique. That’s why we offer flexible cleaning schedules and customized plans that fit your lifestyle. Whether you’re looking for regular housekeeping, one-time deep cleaning, or festive cleaning assistance, our team ensures professional quality and consistency every time.</p>
              </div>

              {/* Why Choose - Modern Square Grid */}
              <div className="why-choose-square">
                <h3>Why Choose Tanya Maid Service?</h3>
                <div className="grid-features">
                  <div className="feature-square">
                    <FaCheck className="blue-icon" />
                    <p><strong>Trained and Verified Maids:</strong> Each maid is carefully screened, background-checked, and trained to handle all cleaning tasks with care and professionalism.</p>
                  </div>
                  <div className="feature-square">
                    <FaCheck className="blue-icon" />
                    <p><strong>Flexible Cleaning Plans:</strong> Choose from daily, weekly, or monthly cleaning options based on your preferences.</p>
                  </div>
                  <div className="feature-square">
                    <FaCheck className="blue-icon" />
                    <p><strong>Eco-Friendly Cleaning:</strong> We focus on safe, hygienic, and eco-friendly cleaning solutions for a healthier home environment.</p>
                  </div>
                  <div className="feature-square">
                    <FaCheck className="blue-icon" />
                    <p><strong>Affordable Pricing:</strong> Get premium cleaning services at prices that match your budget.</p>
                  </div>
                  <div className="feature-square">
                    <FaCheck className="blue-icon" />
                    <p><strong>Customer Satisfaction:</strong> We deliver excellence through attention to detail, reliability, and personalized service.</p>
                  </div>
                </div>
              </div>

              <div className="summary-footer-box">
                <p>Our House Cleaning Services Mumbai cover every corner of your home—bedrooms, bathrooms, kitchens, living areas, and balconies. From mopping floors and dusting furniture to washing dishes and sanitizing surfaces, our maids handle it all efficiently. We also offer deep cleaning packages that include sofa cleaning, window washing, and bathroom sanitization.</p>
              </div>
              <div className="summary-footer-box">
                <p>Hiring a maid shouldn’t be complicated. With Tanya Maid Service, the process is easy and transparent. Simply get in touch with us, share your cleaning requirements, and we’ll assign a Trusted Cleaning Maid Mumbai who matches your specific needs. Our maids arrive on time, work diligently, and leave your home looking and feeling fresh.</p>
              </div>
              <div className="summary-footer-box">
                <p>When you Hire Cleaning Maid Mumbai through Tanya Maid Service, you’re choosing peace of mind, hygiene, and professionalism. We take pride in offering Professional Maid Services Mumbai that blend quality, safety, and reliability, ensuring that our clients receive unmatched value and satisfaction.</p>
              </div>
            </div>

            {/* Square Sidebar */}
            <aside className="sidebar-square">
              {/* ACTIVE SEARCH BOX */}
      <div className="search-container-premium">
        <div className="search-square">
          <input
            type="text"
            placeholder="SEARCH SERVICES..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <button><FaSearch /></button>
        </div>

        {/* Search Results Dropdown */}
        {searchTerm && (
          <div className="search-results-dropdown">
            {filteredServices.length > 0 ? (
              filteredServices.map((service, index) => (
                <div
                  key={index}
                  className="result-item"
                  onClick={() => navigate(service.path)}
                >
                  {service.name}
                </div>
              ))
            ) : (
              <div className="no-result">No services found</div>
            )}
          </div>
        )}
      </div>

              <div className="list-widget">
                <h5>OUR SERVICES</h5>
                <ul className="square-links">
  <li>
    <Link to="/services/patient-care-service-in-mumbai">
      Patient Care <FaArrowRight />
    </Link>
  </li>

  <li>
    <Link to="/services/baby-care-service-in-mumbai">
      Baby Care <FaArrowRight />
    </Link>
  </li>

  <li>
    <Link to="/services/house-maid-service-in-mumbai">
      House Maid <FaArrowRight />
    </Link>
  </li>

  <li>
    <Link to="/services/cooking-service-in-mumbai">
      Cooking <FaArrowRight />
    </Link>
  </li>

  <li>
    <Link to="/services/driver-service-in-mumbai">
      Driver <FaArrowRight />
    </Link>
  </li>

  <li>
    <Link
      to="/services/home-cleaning-service-in-mumbai"
      className="active-item"
    >
      Home Cleaning <FaArrowRight />
    </Link>
  </li>

  <li>
    <Link to="/services/japa-maid-service-in-mumbai">
      Japa Maid <FaArrowRight />
    </Link>
  </li>
</ul>
              </div>

<div className="contact-box-square">
  <div className="cta-overlay-square">
    <div className="cta-icon-square">
      <FaPhoneAlt />
    </div>
    <h3 className="cta-title-square">Call us Today!</h3>
    <a href="tel:+917304398067" className="cta-phone-square">
      +91 73043 98067
    </a>
    <a href="mailto:info@tanyamaidservice.com" className="cta-email-square">
      info@tanyamaidservice.com
    </a>
  </div>
</div>
            </aside>

          </div>
        </div>
      </section>
    </div>
  );
};

export default HomeCleaningService;